function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxlC2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "swatch12"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 0.17000002
    },
    offset: 0,
    id: "stop12"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 20.798929,7.1736614 a 1.51,1.51 0 0 0 -0.55,-0.57 l -7.34,-4.24 a 1.67,1.67 0 0 0 -1.54,0 l -7.3399999,4.24 a 1.68,1.68 0 0 0 -0.77,1.33 v 8.4799996 a 1.57,1.57 0 0 0 0.22,0.76 1.51,1.51 0 0 0 0.55,0.57 l 7.3399999,4.24 a 1.67,1.67 0 0 0 1.54,0 l 7.34,-4.24 a 1.51,1.51 0 0 0 0.55,-0.57 1.57,1.57 0 0 0 0.22,-0.76 V 7.9336614 a 1.57,1.57 0 0 0 -0.22,-0.76 z m -8.66,10.9199996 a 5.92,5.92 0 1 1 5.13,-8.9199996 l -1.13,0.71 -0.36,0.1999996 -1,0.61 a 3,3 0 0 0 -5.6399999,1.48 2.88,2.88 0 0 0 0.4,1.48 3,3 0 0 0 5.1299999,0 l 2.6,1.52 a 5.94,5.94 0 0 1 -5.13,2.92 z m 5.92,-5.59 h -0.66 v 0.67 h -0.65 v -0.66 h -0.61 v -0.66 h 0.66 v -0.68 h 0.65 v 0.66 h 0.66 z m 2.47,0 h -0.66 v 0.67 h -0.66 v -0.66 h -0.65 v -0.66 h 0.65 v -0.68 h 0.66 v 0.66 h 0.66 z",
    id: "path1",
    style: {
      fill: "#cdd6f4",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#cdd6f4",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000000",
      strokeDasharray: "0, 11",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect12",
    width: 4.7583213,
    height: 3.0564394,
    x: 16.046309,
    y: 10.523879
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#cdd6f4",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000000",
      strokeDasharray: "0, 11",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "rect13",
    width: 0.20839363,
    height: 0.034732271,
    x: 20.492041,
    y: 12.364689
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxlC2);
export default __webpack_public_path__ + "static/media/bxl-c-2.277eaf7c092e8975b44e5f292965df90.svg";
export { ForwardRef as ReactComponent };